import { render, staticRenderFns } from "./custom_alert.vue?vue&type=template&id=71b7f53e&scoped=true&"
import script from "./custom_alert.vue?vue&type=script&lang=js&"
export * from "./custom_alert.vue?vue&type=script&lang=js&"
import style0 from "./custom_alert.vue?vue&type=style&index=0&id=71b7f53e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b7f53e",
  null
  
)

export default component.exports